
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import WidgetData, { ChartData } from "@/interfaces/dashboard/WidgetData";
import Chart from "chart.js";
import { generateUID } from "@/utils/misc";

@Component({
  components: {},
})

export default class DefaultChart extends Vue {

  @Prop({ default: {} })
  public widgetData: WidgetData;
  @Prop({ required: true })
  public chartType: string;
  public id: string = generateUID();
  public ctx: any;
  public chart: any;

  public mounted() {
    this.ctx = document.getElementById(this.id.toString());
    this.createChart();
  }

  private translateDatasets(datasets) {
    const key = `Widgets.${this.widgetData.type}.datasets.label`;
    return datasets.map((dataset) => ({
      ...dataset,
      label: this.$t(key) === key ? dataset.label : this.$t(key, { label: dataset.label }),
    }));
  }

  private translateLabels(labels) {
    return labels.map((label) => {
      const key = `Widgets.${this.widgetData.type}.labels.${label}`;
      return this.$t(key) === key ? label : this.$t(key);
    });
  }

  private createChart() {
    this.chart = new Chart(this.ctx, {
      type: this.chartType,
      data: {
        labels: this.translateLabels((this.widgetData.data as ChartData).labels),
        datasets: this.translateDatasets((this.widgetData.data as ChartData).datasets),
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
      },
    });

  }

}
